import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { statusType } from '../interfaces/enumStatusType';

interface Msg {
    text: string,
    headline: string
    msg?: Msg
}
export interface ErrorMsg {
    error?: {
        msg: {
            text: string,
            headline: string
        }
    };
    text: string,
    headline: string
}

@Injectable({
    providedIn: 'root'
})
export class SnackService {
    snackText = new BehaviorSubject<string>('');
    snackHeadline = new BehaviorSubject<string>('');
    showSnack = new BehaviorSubject<boolean>(false);
    type = new BehaviorSubject<statusType>(statusType.Info);
    constructor() { }

    async success(text: Msg): Promise<void> {
        let msg = text;
        if (msg.msg) msg = msg.msg;
        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline);
        this.type.next(statusType.Success);
        this.showSnack.next(true);
    }
    async error(text: ErrorMsg): Promise<void> {
        console.log(text);

        let msg = text;
        if (msg.error?.msg?.headline && msg.error.msg.text) msg = msg.error.msg;
        if (!msg.text && !msg.headline) {
            // Set default error message
            msg = { text: "An unexpected error occurred. Please try again later.", headline: 'Error' };
        }
        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline);
        this.type.next(statusType.Error);
        this.showSnack.next(true);
    }
    async warning(text: Msg): Promise<void> {
        let msg = text;
        if (msg.msg) msg = msg.msg;
        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline);
        this.type.next(statusType.Warning);
        this.showSnack.next(true);
    }
    async info(text: Msg): Promise<void> {
        let msg = text;
        if (msg.msg) msg = msg.msg;
        this.snackText.next(msg.text);
        this.snackHeadline.next(msg.headline);
        this.type.next(statusType.Neutral);
        this.showSnack.next(true);
    }
    async close(): Promise<void> {
        this.showSnack.next(false);
    }
}

